import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import apiHelper from "../../../util/ApiHelper";
import _ from "lodash";
import { toast } from "react-toastify";
import { useLoading } from "../../../util/LoadingProvider";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import editorConfiguration from "../../../util/EditorConfiguration";
import {
  modal
} from "../../../util";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";

const schema = yup.object().shape({

});
const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
  },
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  input: {
    width: "100%",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
  box: {
    padding: 0,
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  sectionText: {
    fontSize: "13px",
    fontWeight: 700,
    paddingLeft: "4px",
  },
  imageGallery: {
    border: "1px solid #CCCCCC",
    minHeight: "160px",
    borderRadius: "3px",
    position: "relative",
  },
  imageGalleryControl: {
    position: "relative",
    width: "100%",
    display: "flex",
    height: "40px",
    bottom: "0",
    borderTop: "1px solid #CCCCCC",
    padding: "5px",
  },
  imageGalleryBlk: {
    minHeight: "120px",
    padding: "5px",
  },
  imgPreview: {
    maxWidth: "200px",
    margin: "10px",
    display: "inline-flex",
    "& img": {
      width: "100%",
      height: "auto",
    },
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const defaultFormValues = {
  "pageTitleTc": "",
  "pageTitleEn": "",
  "highLightsTc": "",
  "highLightsEn": "",
  "contentTc": "",
  "contentEn": "",
  "thanksTc": "",
  "thanksEn": "",
  "contactBoxTc": "",
  "contactBoxEn": "",
  "type": "",
  "sequence": ""
}

export default function SupportUsDetailPage({ disabled, ...props }) {
  const { match } = props;
  const history = useHistory();
  const id = match.params.id;
  const classes = useStyles();
  const [language, setLanguage] = React.useState(0);
  const [defaultValues, setDefaultValues] = useState(defaultFormValues);
  const [data, setData] = React.useState(null);
  const { setLoading } = useLoading();
  const [formError, setFormError] = React.useState({});
  const [type, setType] = React.useState("2");

  const { control, handleSubmit, getValues, setValue, reset, formState } =
    useForm({
      defaultValues,
      resolver: yupResolver(schema),
    });

  const getSupportUs = React.useCallback(async () => {
    setLoading(true);
    try {
      const result = await apiHelper.hkiff.getSupportUsById(id);
      console.log(result);
      setDefaultValues(result.data);
      setType(result.data.type);
      console.log(result.data.type);
      reset(result.data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }, [id, setLoading]);

  const handleChange = (event, newValue) => {
    setLanguage(newValue);
  };

  const onSubmit = (value) => {
    console.log('id is::' + id);
    if (id !== "new") updateSupportUs(value);
    else createSupportUs(value);
  };

  const updateSupportUs = async (value) => {
    //for updating history culture
    try {
      setLoading(true);
      const req = {
        ...value,
      };
      console.log(value);
      console.log('id is:' + id);
      const result = await apiHelper.hkiff.updateSupportUsById(id, req);
      if (result.data) {
        toast.dark("Your changes are saved.");
        getSupportUs();
        history.push("/hkiff/support-us/" + id);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const createSupportUs = async (value) => {
    try {
      const result = await apiHelper.hkiff.createSupportUs(value);
      console.log(result);
      if (result.data.id !== null || result.data.id !== undefined) {
        history.push("/hkiff/support-us");
        toast.dark("The support us is created.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  React.useEffect(() => {
    console.log(formError);
    if (!_.isEqual(formError, formState.errors)) {
      setFormError(formState.errors);
      if (formState.errors?.localizations?.en) {
        setLanguage(0);
        return;
      }
      if (formState.errors?.localizations?.tc) {
        setLanguage(1);
        return;
      }
    }
  }, [formState, formError]);

  // React.useEffect(() => {
  //   setData(defaultFormValues);
  //   getSupportUs();
  // }, []);

  useEffect(() => {
    if (id !== "new") getSupportUs();
  }, [getSupportUs, id]);


  const deleteSupportUs = async () => {
    const decision = await modal.fire({
      title: "Delete support us",
      text: "Are you sure to delete this support us?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.hkiff.deleteSupportUsById(id);
        history.push("/hkiff/support-us");
        toast.dark("The support us has been deleted.");
      } catch (err) {
        console.log(err);
      }
    }
  };


  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        Support Us
      </Typography>
      <Tabs
        value={language}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{ style: { top: "0", background: "#306F9D" } }}
      >
        <Tab label="English" {...a11yProps(0)} />
        <Tab label="繁體中文" {...a11yProps(1)} />
      </Tabs>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <TabPanel value={language} index={0}>
            <Box className={classes.innerBox}>
              <Grid container direction="vertical" spacing={3}>

                <Grid container item xs={12}>

                  <Grid item xs={12}>
                    <Controller
                      name="pageTitleEn"
                      rules={{ required: "Required" }}
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          label="Page Title"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          error={!!error}
                          helperText={error ? error.message : "The name is how it appears on your site."}
                        />
                      )}
                    />
                  </Grid>
                  
                  <Grid container item xs={12}>
                    <Grid item xs={12}>
                      <strong className={classes.sectionText}>Type</strong>
                    </Grid>
                    <Grid item xs={12}>
                    <FormControl fullWidth margin="dense" variant="outlined">
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              value={type}
                              onChange={(e) => {
                                setValue(`type`, e.target.value);
                                setType(e.target.value);
                              }}
                              label="Type"
                              disabled={disabled}
                            >
                              <MenuItem value={"1"}>1</MenuItem>
                              <MenuItem value={"2"}>2</MenuItem>
                            </Select>
                          </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container item xs={12}>
                    <Grid item xs={12}>
                      <strong className={classes.sectionText}>Highlight</strong>
                    </Grid>
                    <Grid item xs={12}>
                      <Controller
                        name="highLightsEn"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CKEditor
                            editor={Editor}
                            config={editorConfiguration}
                            data={field.value}
                            disabled={disabled}
                            onReady={(editor) => {
                              // You can store the "editor" and use when it is needed.
                              console.log("Editor is ready to use!", editor);
                              editor.setData(
                                defaultValues.highLightsEn
                              );
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              field.onChange(data);
                              // console.log({ event, editor, data });
                            }}
                            onBlur={(event, editor) => {
                              console.log("Blur.", editor);
                            }}
                            onFocus={(event, editor) => {
                              console.log("Focus.", editor);
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Description</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="contentEn"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.contentEn
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>


                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Remarks</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="thanksEn"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.thanksEn
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>


                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Contact Info</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="contactBoxEn"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.contactBoxEn
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>


              </Grid>


            </Box>

          </TabPanel>


          <TabPanel value={language} index={1}>
            <Box className={classes.innerBox}>
              <Grid container direction="vertical" spacing={3}>

                <Grid container item xs={12}>

                  <Grid item xs={12}>
                    <Controller
                      name="pageTitleTc"
                      rules={{ required: "Required" }}
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          label="Page Title"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          error={!!error}
                          helperText={error ? error.message : "The name is how it appears on your site."}
                        />
                      )}
                    />
                  </Grid>

                  <Grid container item xs={12}>
                    <Grid item xs={12}>
                      <strong className={classes.sectionText}>Highlight</strong>
                    </Grid>
                    <Grid item xs={12}>
                      <Controller
                        name="highLightsTc"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CKEditor
                            editor={Editor}
                            config={editorConfiguration}
                            data={field.value}
                            disabled={disabled}
                            onReady={(editor) => {
                              // You can store the "editor" and use when it is needed.
                              console.log("Editor is ready to use!", editor);
                              editor.setData(
                                defaultValues.highLightsTc
                              );
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              field.onChange(data);
                              // console.log({ event, editor, data });
                            }}
                            onBlur={(event, editor) => {
                              console.log("Blur.", editor);
                            }}
                            onFocus={(event, editor) => {
                              console.log("Focus.", editor);
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Description</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="contentTc"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.contentTc
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>


                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Remarks</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="thanksTc"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.thanksTc
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>


                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Contact Info</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="contactBoxTc"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.contactBoxTc
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>


              </Grid>


            </Box>


          </TabPanel>


          {disabled || (
            <div className={classes.buttonGroup}>

              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                Save Changes
              </Button>
              {match.params.id && (
                <Button
                  variant="contained"
                  disableElevation
                  style={{
                    color: "white",
                    background: "#962013",
                    padding: "9px 16px",
                  }}
                  onClick={deleteSupportUs}
                >
                  Delete
                </Button>
              )}
            </div>
          )}
        </fieldset>
      </form>
    </div>
  );
}
